import { DirectSalesLine, DirectSalesStatusOption } from 'components/common/types/DirectSalesCampaign.types';

export const isCampaignCancelled = (lines: Partial<DirectSalesLine>[]): boolean => {
  return (
    !!lines.length && lines.every((line: DirectSalesLine) => line.state.status === DirectSalesStatusOption.CANCELLED)
  );
};
